const filter = (items, key) => items.filter((obj) => obj.key === key);


export const tabs = {
  INVOICES_REGISTERED_TODAY: 'INVOICES_REGISTERED_TODAY',
  DURING_PROCESSING: 'DURING_PROCESSING',
  SOLD_INVOICES_TODAY: 'SOLD_INVOICES_TODAY',
};

export const getTableItems = (items, tab) => {
  switch (tab) {
    case tabs.INVOICES_REGISTERED_TODAY:
      return filter(items, 'InvoicesRegisteredToday');

    case tabs.DURING_PROCESSING:
      return filter(items, 'DuringProcessing');

    case tabs.SOLD_INVOICES_TODAY:
      return filter(items, 'SoldInvoicesToday');

    default:
      return items;
  }
};

export const createSummary = (items) => {
  const invoicesRegisteredToday = filter(items, 'InvoicesRegisteredToday');
  const duringProcessing = filter(items, 'DuringProcessing');
  const soldInvoicesToday = filter(items, 'SoldInvoicesToday');

  const sumTotalAmount = (invoices) => invoices.reduce((acc, obj) => acc + obj.normalizedTotalAmount, 0);
  const getCurrencyCode = (invoices) => (invoices.length > 0 ? invoices[0].normalizedCurrencyCode : '');

  return {
    invoicesRegisteredToday: {
      numberAmount: invoicesRegisteredToday.length,
      sumAmount: sumTotalAmount(invoicesRegisteredToday),
      currencyCode: getCurrencyCode(invoicesRegisteredToday),
    },
    duringProcessing: {
      numberAmount: duringProcessing.length,
      sumAmount: sumTotalAmount(duringProcessing),
      currencyCode: getCurrencyCode(duringProcessing),
    },
    soldInvoicesToday: {
      numberAmount: soldInvoicesToday.length,
      sumAmount: sumTotalAmount(soldInvoicesToday),
      currencyCode: getCurrencyCode(soldInvoicesToday),
    },
  };
};
